import _ from 'lodash';
import { Model } from './Model';

/*
validate() {
 * @property id
 * @property name
 * @property firstName
 * @property lastName
 * @property displayName
 * @property type
 * @property flags
}
*/
export class Person extends Model {

  static validators = {
  };

  /**
   * @property id
   *
   * ID.
   *
   * @type {string}
   */

  /*
   * @property name
   *
   * Name.
   *
   * @type {string}
   */

  /*
   * @property firstName
   *
   * First name.
   *
   * @type {string}
   */

  /*
   * @property lastName
   *
   * Last name.
   *
   * @type {string}
   */

  /*
   * @property displayName
   *
   * Display name.
   *
   * @type {string}
   */

  /**
   * @property type
   *
   * Type.
   *
   * @type {string}
   */

  /**
   * @property flags
   *
   * Flags.
   *
   * @type {string[]}
   */

  constructor( opts={} ) {
    super( opts );
    if ( ( this.firstName || this.lastName ) && ! this.name ) {
      this.name = _.compact( [ this.firstName, this.lastName ] ).join( ' ' );
    }
    /*
    if ( ! this.displayName ) {
      const displayNameOptions = [ 'firstName', 'name' ]; // TODO - config
      for ( const opt of displayNameOptions ) {
        if ( ! this[ opt ] ) continue;
        this.displayName = this[ opt ];
        break;
      }
    }
    */
  }

}
